/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  permissionUtil.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/1/19 11:26
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

import { flattenTree } from "@/utils/util";
import { SysMenuDTO } from "@/api/sys-auth";
import { RouteRecord } from "vue-router/types/router";

export interface MenuRoute extends RouteRecord {
  key?: string;
  _indexPath?: number[];
  hidden?: boolean;
  component?: any;
  children?: MenuRoute[];
  hideChildrenInMenu?: boolean;
}
/**
 * 过滤账户是否拥有某一个权限，并将菜单从加载列表移除
 *
 * @param menu
 * @param route
 * @returns {boolean}
 */
function hasPermission (
  menu: SysMenuDTO | undefined,
  route: any
): menu is SysMenuDTO {
  if (route.meta && route.meta.permission) {
    if (menu) {
      route.meta = route.meta || {};
      route.meta._id = menu.id;
      return true;
    } else {
      return false;
    }
  }
  return !!menu;
}

function setIndexMark (data: any[], indexPath: number[] = []) {
  data.forEach((i, index) => {
    i._indexPath = indexPath.concat(index);
    if (i.children) {
      setIndexMark(i.children, i._indexPath);
    }
  });
}

function deleteRoute (data: MenuRoute[], treeData: MenuRoute[]) {
  data.forEach((i) => {
    if (i.meta && i.meta.permission && !i.meta.hasPermission) {
      let item = treeData;
      for (let index = 0; index < i._indexPath!.length; index++) {
        const treeIndex = i._indexPath![index];
        if (index === i._indexPath!.length - 1) {
          // @ts-ignore
          item[treeIndex] = null;
        } else if (item[treeIndex]) {
          item = item[treeIndex].children!;
        } else {
          break;
        }
      }
    }
    return true;
  });
}

function filterNullRoute (treeData: MenuRoute[], pMenu?: MenuRoute) {
  return treeData.filter((i) => {
    if (i) {
      // if (pMenu && pMenu.meta && pMenu.meta.permission && pMenu.meta.permission instanceof Array) {
      //   i.meta.permission = i.meta.permission.concat(pMenu.meta.permission)
      // }
      if (i.children) {
        i.children = filterNullRoute(i.children, i);
        if (i.children.length) {
          i.redirect = { name: i.children[0].name };
        }
      }
      return true;
    } else {
      return false;
    }
  });
}

interface GenerateMenuOptions {
  routes: MenuRoute[];
  menus: SysMenuDTO[];
}

export function generateMenu (options: GenerateMenuOptions) {
  // eslint-disable-next-line prefer-const
  let { routes, menus } = options;
  // 给每个节点打上路径标识，例如：_indexPath: [0, 1]
  setIndexMark(routes!);
  // 展平树结构
  const mainRouteChild = flattenTree(routes!).filter(
    (i) => i.meta && i.meta.permission
  );
  // 遍历菜单并给有权限的节点打上标记hasPermission=true
  const menuData = filterAsyncRouter(menus, mainRouteChild);
  // 将无权限的节点设置为null
  deleteRoute(mainRouteChild, routes!);
  // 过滤为null的节点并根据子节点设置redirect重定向
  routes = filterNullRoute(routes!);
  // 合并报表路由
  routes = routes.concat(
    mainRouteChild.filter((i) => i.meta && i.meta.isReport)
  );
  // 返回菜单数据和路由数据
  return {
    menuData,
    routes,
  };

  function filterAsyncRouter (
    menuTree: SysMenuDTO[],
    routeList: MenuRoute[],
    parentKeys: string[] = []
  ) {
    return menuTree.filter((menu) => {
      const routeIndex = routeList.findIndex(
        (route) => route.name === menu.menuUrl
      );
      if (menu.children) {
        menu.children = filterAsyncRouter(
          menu.children,
          routeList,
          parentKeys.concat(menu.id)
        );
      }
      if (routeIndex !== -1) {
        const route = routeList[routeIndex];
        route.meta = route.meta || {};
        route.meta._id = menu.id;
        route.meta.permission = (menu.children || []).map((i) => i.actionName);
        route.meta.hasPermission = true;
        route.meta.parentKeys = parentKeys.concat(menu.id);
        // menu.routePath = route.path
      }
      return true;
    });
  }
}
